/**
 * Quicklinks.
 */

/**
 * Handle quicklink menu link so it doesn't affect history.
 */
function handleQuicklink( e ) {
	// Check if tab has been clicked.
	const link = e.target;
	if ( link.tagName !== 'A' || ! link.hasAttribute( 'aria-controls' ) ) {
		return;
	}

	// Once the event reaches a link, stop propagation.
	e.preventDefault();
	//history.replaceState( null, null, e.target.href );
	e.stopPropagation();
	console.log(link);

	const menu = e.currentTarget;

	// Find the target menu element.
	const target = document.getElementById( link.getAttribute( 'aria-controls' ) );

	if ( target ) {

		// Loop over all links in the menu.
		menu.querySelectorAll( 'a[aria-controls]' ).forEach( ( menuLink ) => {

			if ( menuLink === link ) {

				// Check if target is currently expanded.
				const expanded = target.getAttribute( 'aria-expanded' ) === 'true';

				if ( expanded ) {
					link.setAttribute( 'aria-expanded', 'false' );
					target.setAttribute( 'aria-expanded', 'false' );

					// Disallow submenu link focus.
					target.querySelectorAll( 'a' ).forEach( ( a ) => {
						a.setAttribute( 'tabindex', '-1' );
					} );
				}
				else {
					link.setAttribute( 'aria-expanded', 'true' );
					target.setAttribute( 'aria-expanded', 'true' );

					// Allow submenu link focus, set focus on first item.
					let first = true;
					target.querySelectorAll( 'a' ).forEach( ( a ) => {
						a.removeAttribute( 'tabindex' );
						if ( first ) {
							a.focus({ preventScroll: true });
							first = false;
						}
					} );
				}
			}
			// If not the current link, close the menu.
			else {
				// Check if target is currently expanded.
				if ( menuLink.getAttribute( 'aria-expanded' ) === 'true' ) {
					menuLink.setAttribute( 'aria-expanded', 'false' );
					const menuLinkTarget = document.getElementById( menuLink.getAttribute( 'aria-controls' ) );
					menuLinkTarget.setAttribute( 'aria-expanded', 'false' );

					// Disallow submenu link focus.
					menuLinkTarget.querySelectorAll( 'a' ).forEach( ( a ) => {
						a.setAttribute( 'tabindex', '-1' );
					} );
				}
			}
		} );
	}
}

export const applyQuicklinks = ( targetSelector ) => {
	const targets = document.querySelectorAll( targetSelector );

	if ( targets.length === 0 ) {
		return;
	}

	targets.forEach( ( target ) => {
		// Setup event listeners.
		target.addEventListener( 'click', handleQuicklink );
		//target.addEventListener( 'focusout', handleFocusout );

		// Setup main tab links.
		let first = true;
		target.querySelectorAll( '.menu-item-has-children a' ).forEach( ( link ) => {
			// Get plain href value (without full URL).
			const href = link.getAttribute( 'href' );
			if ( href && href.startsWith( '#' ) ) {
				const target = document.getElementById( href.substring(1) );

				if ( ! target ) {
					return;
				}

				// Setup aria attributes.
				link.setAttribute( 'aria-haspopup', 'true' );
				link.setAttribute( 'aria-expanded', first ? 'true' : 'false' );
				link.setAttribute( 'aria-controls', target.id );
				target.setAttribute( 'aria-expanded', first ? 'true' : 'false' );

				first = false;
			}
		} );

		// Set initial state of child links.
		target.querySelectorAll( '.sub-menu[aria-expanded="false"] a' ).forEach( ( link ) => {
			link.setAttribute( 'tabindex', '-1' );
		} );
	} );
}
